<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'App',
		
		computed: {
			...mapState(['userInfo', 'systemConfig']),
		},
		
		watch: {
			userInfo() {
				this.resetSubmodule();
			},
			
			systemConfig() {
				this.updateWebInfo();
			}
		},
		
		created() {
			this.updateWebInfo();
			this.$store.dispatch('getSystemConfig');
		},
		
		methods: {
			updateWebInfo() {
				if (this.SAAS) {
					window.document.documentElement.setAttribute('saas', true);
				}
				let ico = document.querySelector('link[rel="shortcut icon"]');
				if (ico) {
					ico.href = this.SAAS ? this.systemConfig.seller_favicon : this.systemConfig.scs_favicon
				} else {
					var head = document.getElementsByTagName('head')[0];
					var link = document.createElement('link');
					link.rel = 'shortcut icon';
					link.href = this.SAAS ? this.systemConfig.seller_favicon : this.systemConfig.scs_favicon;
					head.appendChild(link);
				}

				if (this.$route.path != '/chat') {
					document.title = (this.SAAS ? this.systemConfig.seller_system_name : this.systemConfig.scs_system_name) || '商家管理后台';
				}
			}
		}
	}
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';
	
	.c-module-content {
		> div > .c-table {
			margin: 0 20px;
			
			.c-pagination {
				padding: 0;
			}
		}
	}
</style>